import { useTradeSettingStore } from '@/client/store/trade-store';

export const useTradeSettings = () => {
  const deadlineMinutes = useTradeSettingStore(state => state.deadline);
  const slippage = useTradeSettingStore(state => state.slippage);
  const isAutoSlippage = useTradeSettingStore(state => state.isAutoSlippage);

  return {
    deadlineMinutes,
    slippage,
    isAutoSlippage,
  };
};
